module.exports = __webpack_public_path__ + "static/media/textField.c80789ef.png";